/*
Tab Pulls
  --length <float> | inches
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Tab'
const id = 'DhK7DV9NKBSYLRsdSEOT'

export default {
  name,
  id,
  filters,
  headers,
  form
}
